import capitalize from 'lodash/capitalize';
import pluralize from 'pluralize';
import { memo, useMemo } from 'react';

import { useSubscriptionContext } from '~/providers/SubscriptionProvider';
import { formatTrialEndDate, getTrialDurationDays } from '~/utils/SubscriptionUtils';

export const TrialCTA = memo(() => {
  const { data: subscription } = useSubscriptionContext();

  const planName = useMemo(
    () => (subscription?.plan ? capitalize(subscription.plan) : 'your plan'),
    [subscription?.plan],
  );

  const trialDurationDays = useMemo(() => {
    if (!subscription?.purchaseDate || !subscription?.trialEndDate) {
      return null;
    }

    return getTrialDurationDays(subscription.purchaseDate, subscription.trialEndDate);
  }, [subscription?.purchaseDate, subscription?.trialEndDate]);

  const formattedDate = useMemo(() => {
    if (!subscription?.trialEndDate) {
      return null;
    }

    return formatTrialEndDate(subscription.trialEndDate);
  }, [subscription?.trialEndDate]);

  if (!formattedDate || trialDurationDays === null) {
    return null;
  }

  return (
    <div className="mt-3 mb-4 flex flex-col rounded-4 border border-grey-4 bg-grey-2 p-2 text-left text-grey-11">
      <div className="flex w-full">
        <p className="flex-1 font-semibold text-12">Currently on a trial</p>
      </div>
      <p className="mt-1 whitespace-pre-wrap text-12">
        Your {pluralize('day', trialDurationDays, true)} trial of {planName} will expire on {formattedDate}.
      </p>
    </div>
  );
});

TrialCTA.displayName = 'TrialCTA';
